import React from 'react';
import {MarkdownPreview} from './MarkdownPreview';
import TextArea from '../../components/TextArea';
import {AnimatedSVG} from '../../components/Spinner';
import {PresentationPrototype} from '../../../incase-domain/presentationPrototype';

export interface GeneratorContentProps {
    prototype: PresentationPrototype | undefined;
    isEditing: boolean;
    onContentChange: (content: string) => void;
    isLoading: boolean;
    isPdfParsing: boolean;
    pdfProgress: number;
}

function GeneratorContent({
    prototype,
    isEditing,
    onContentChange,
    isLoading,
    isPdfParsing,
    pdfProgress,
}: GeneratorContentProps): JSX.Element {
    return (
        <div className="c-generatorPage__contentWrapper">
            <div className="c-generatorPage__content">
                {prototype && isEditing && <TextArea fullHeight value={prototype.content || ''} onChange={onContentChange} />}
                {prototype && !isEditing && <MarkdownPreview content={prototype.content || ''} />}
            </div>
            {isLoading && (
                <div className="c-generatorPage__loadingOverlay">
                    <AnimatedSVG />
                    {isPdfParsing && (
                        <div className="c-generatorPage__pdfProgress">
                            <div className="c-generatorPage__pdfProgress_background" />
                            <div className="c-generatorPage__pdfProgress_foreground" style={{width: `${pdfProgress * 100}%`}} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default GeneratorContent;
